var _circle, _circle2, _path, _path2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconChatUser = function SvgIconChatUser(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2446,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_286_1980)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2446,
    cy: 12,
    r: 12,
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24463 7.19043V6.19043C9.24463 5.63814 9.69234 5.19043 10.2446 5.19043H14.2446C14.7969 5.19043 15.2446 5.63814 15.2446 6.19043V7.19043",
    stroke: "white",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6115 8.65039L11.6231 8.65429H8.24463V18.6543H16.2446V8.65429H13.0461C13.0448 8.65299 13.0436 8.65169 13.0423 8.65039H11.6115ZM13.0461 8.65429H11.6231L11.7495 8.69705C12.0649 8.80364 12.4734 9.05164 12.6979 9.4232C12.8881 9.73803 12.9785 10.1934 12.6571 10.8453L11.5011 11.0335C11.3968 11.0505 11.304 11.1096 11.2446 11.197L9.65874 13.5292C9.54174 13.7012 9.58261 13.9351 9.75102 14.0573L11.3287 15.2019C11.5025 15.3279 11.7457 15.2875 11.8694 15.1121L13.5796 12.6868C13.6472 12.5909 13.6674 12.4694 13.6344 12.3568L13.304 11.228C13.7533 10.3506 13.6846 9.60609 13.3398 9.03539C13.2546 8.89425 13.1546 8.76741 13.0461 8.65429ZM6.24463 8.65429C5.69189 8.65429 5.24463 9.10202 5.24463 9.65429V17.6543C5.24463 18.2066 5.69189 18.6543 6.24463 18.6543H7.24463V8.65429H6.24463ZM18.2446 18.6543H17.2446V8.65429H18.2446C18.7974 8.65429 19.2446 9.10202 19.2446 9.65429V17.6543C19.2446 18.2066 18.7974 18.6543 18.2446 18.6543ZM11.7765 11.7485L12.6341 11.6089L12.8652 12.3985L11.4697 14.3776L10.478 13.6581L11.7765 11.7485Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_286_1980",
    x1: 26.9063,
    y1: -6.89803,
    x2: -2.4256,
    y2: 18.5406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#07808F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#067989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#056777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#02495B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D40"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChatUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-chat-user.2d8fa6f0.svg";
export { ForwardRef as ReactComponent };